// Chi tiết's name search. Import-free, for node --test.

/** Lower-case without diacritics, đ as d: "Đức" finds "duc". */
export function foldSearch(text: string): string {
  return String(text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/\s+/g, ' ').trim();
}

/** Rows whose text holds the query, accents ignored; an empty query keeps them all. */
export function filterByName<T>(rows: T[], query: string, textOf: (row: T) => string): T[] {
  const needle = foldSearch(query);
  if (!needle) return rows;
  return rows.filter((row) => foldSearch(textOf(row)).indexOf(needle) >= 0);
}
